import { render, staticRenderFns } from "./SubjectInfoform.vue?vue&type=template&id=652d088c&scoped=true&"
import script from "./SubjectInfoform.vue?vue&type=script&lang=js&"
export * from "./SubjectInfoform.vue?vue&type=script&lang=js&"
import style0 from "./SubjectInfoform.vue?vue&type=style&index=0&id=652d088c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d088c",
  null
  
)

export default component.exports